<template>
  <div class="field-item">
    <div class="field-label">
      {{ field.label }}<i v-if="field.fill_status" class="impor">*</i>
    </div>
    <div class="field-control">
      <!-- PC 端：el-cascader -->
      <el-cascader
        v-if="!isMobile"
        v-model="selected"
        :options="cascaderOptions"
        :props="cascaderProps"
        placeholder="請選擇"
        style="width:100%"
        clearable
        @change="onCascaderChange"
      />
      <!-- 手機端：底部彈層 -->
      <BottomPicker
        v-else
        :options="cascaderOptions"
        v-model="selected"
        placeholder="請選擇"
      />
    </div>
  </div>
</template>

<script>
import BottomPicker from '@/components/mobile/BottomPicker.vue'

export default {
  name: 'FieldSelcet',
  components: { BottomPicker },
  props: { field: Object, value: { default: () => [] } },
  data () {
    return {
      selected: Array.isArray(this.value) ? this.value : [],
      cascaderProps: { checkStrictly: true, expandTrigger: 'click' }
    }
  },
  computed: {
    isMobile () {
      return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent)
    },
    cascaderOptions () {
      return this.buildOptions(this.field.children || [])
    }
  },
  watch: {
    selected (val) { this.$emit('input', val || []) }
  },
  methods: {
    buildOptions (children) {
      return (children || []).map(c => {
        const node = { label: c.label, value: c.label }
        if (c.children && c.children.length) {
          node.children = this.buildOptions(c.children)
        }
        return node
      })
    },
    onCascaderChange (val) {
      this.$emit('input', val || [])
    },
    reset () { this.selected = [] }
  }
}
</script>
